// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function(props, state)
{
    if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
    {
        return true;
    }

    const {fields, validFields} = state;

    for (const name in validFields)
    {
        if (validFields[name] === false)
        {
            return false;
        }
    }

    /**
     * First and last name needs to be entered
     */
    if ((fields.is_company && fields.customer_firstname.length === 0) ||
        (!fields.is_company && (fields.customer_firstname.length === 0 || fields.customer_lastname.length === 0)))
    {
        return false;
    }

    if (!fields.is_company && (fields.customer_email.length === 0 || !Validator.validateEmail(fields.customer_email)))
    {
        return false;
    }

    return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/CustomerInformation/simple/CustomerInformation.fulfillment.js